import abTestingIconSrc from "./app-icons/ab-testing.png";
import adminIconSrc from "./app-icons/admin.png";
import assetsIconSrc from "./app-icons/assets.png";
import brandStudioIconSrc from "./app-icons/brand-studio-purple.png";
import canvasIconSrc from "./app-icons/canvas.png";
import contentIconSrc from "./app-icons/content.png";
import drawIconSrc from "./app-icons/draw.png";
import filesIconSrc from "./app-icons/files.png";
import helloWorldIconSrc from "./app-icons/hello-world.png";
import homeIconSrc from "./app-icons/home.png";
import insightsIconSrc from "./app-icons/insights.png";
import integrationsIconSrc from "./app-icons/integrations.png";
import launchpadIconSrc from "./app-icons/launchpad.png";
import ordersIconSrc from "./app-icons/orders.png";
import plansIconSrc from "./app-icons/plans.png";
import productsIconSrc from "./app-icons/products.png";
import reploverseIconSrc from "./app-icons/reploverse.png";
import settingsIconSrc from "./app-icons/settings.png";
import sightglassIconSrc from "./app-icons/sightglass.png";
import siteBuilderIconSrc from "./app-icons/site-builder.png";
import skillsIconSrc from "./app-icons/skills.png";
import supportIconSrc from "./app-icons/support.png";
import tasksIconSrc from "./app-icons/tasks.png";

/**
 * Single source of truth for the Replo agent app icons, shared by every app
 * that renders them (replo-agent, replo-shopify-theme-builder). The artwork
 * lives in `./app-icons` as size-optimized PNGs and is bundled by each
 * consumer, so adding an icon happens once here instead of once per app.
 *
 * The `app-icons.spec.ts` guardrail enforces that these stay small (real PNGs,
 * capped dimensions and bytes) so an oversized master can never ship again.
 */
export const agentAppIconSrc = {
  launchpad: launchpadIconSrc,
  home: homeIconSrc,
  integrations: integrationsIconSrc,
  insights: insightsIconSrc,
  brandStudio: brandStudioIconSrc,
  content: contentIconSrc,
  plans: plansIconSrc,
  skills: skillsIconSrc,
  tasks: tasksIconSrc,
  siteBuilder: siteBuilderIconSrc,
  settings: settingsIconSrc,
  abTesting: abTestingIconSrc,
  reploverse: reploverseIconSrc,
  assets: assetsIconSrc,
  sightglass: sightglassIconSrc,
  canvas: canvasIconSrc,
  helloWorld: helloWorldIconSrc,
  orders: ordersIconSrc,
  products: productsIconSrc,
  files: filesIconSrc,
  draw: drawIconSrc,
  support: supportIconSrc,
  admin: adminIconSrc,
} as const;
